export enum OnlineStoreType {
  Miravia = 'miravia',
  Shopify = 'shopify',
  WooCommerce = 'woocommerce',
}
